import React from "react";
import { Network } from "lucide-react";
import SolutionPageLayout from "./SolutionPageLayout";

// Pathway 7 (Family G) — Portals, Integrations & Executive Visibility
const PortalsIntegrations = () => (
  <SolutionPageLayout
    testId="page-solution-portals-integrations"
    icon={Network}
    overline="Pathway · 07 of 07 · Aligned with Family G"
    title="For Portals, Integrations & Executive Visibility"
    headline="Clearer digital access channels, internal portals, user-facing interfaces, external integrations, mobile access, notifications, reporting structures, dashboards, and executive visibility."
    intro={[
      "For institutions that need clearer digital access channels, internal portals, user-facing interfaces, external integrations, mobile access, notifications, reporting structures, dashboards, and executive visibility.",
      "This pathway helps organizations turn disconnected systems, users, departments, and external services into a more connected management environment.",
    ]}
    supportsOverline="Relevant use cases may include"
    supportsTitle="Where this pathway creates institutional value."
    supports={[
      "Institutional web portals",
      "Citizen, member, patient, tenant, industrialist, or stakeholder portals where applicable",
      "Mobile access for users and managers",
      "Call center and communication workflows",
      "SMS notifications and service alerts",
      "Identity, address, payment, and public-system integration readiness",
      "Single sign-on and role-based access",
      "Dashboard and reporting structures",
      "Executive visibility and decision-support environments",
      "Integration feasibility planning based on local infrastructure and third-party access",
    ]}
    ctaTitle="Build clearer visibility across portals, integrations, and executive decision-making."
    primaryCta={{ label: "Discuss Portals & Visibility Pathway", to: "/contact" }}
    secondaryCta={{ label: "View Product Portfolio", to: "/product-portfolio#portals-integrations-external-systems" }}
  />
);

export default PortalsIntegrations;
